<template>
    <transition name="fade">
        <div class="full-modal">
            <div class="full-modal-body">
                <h2 class="mb-3 text-center">{{ $t("save_configuration") }}</h2>
                <div v-if="errors.message" class="alert alert-danger">
                    {{ errors.message }}
                    <ul>
                        <template v-for="(messages, key) in errors.errors">
                            <li v-for="message in messages">
                                {{ message }}
                            </li>
                        </template>
                    </ul>
                </div>
                <form class="form" @submit.prevent="onSubmit(1)">
                    <div class="form-group">
                        <label for="modalInsertEmail">{{
                            $t("send_email_label")
                        }}</label>
                        <input
                            id="modalInsertEmail"
                            v-model="contact.email"
                            :placeholder="$t('email_placeholder')"
                            required
                            class="form-control"
                            type="email"
                            :class="{ 'is-invalid': errors.errors.email }"
                        />
                    </div>
                    <div class="form-check">
                        <input
                            id="sendEmailPrivacyConsent"
                            v-model="consents.privacy"
                            required
                            class="form-check-input"
                            type="checkbox"
                            :class="{
                                'is-invalid': errors.errors.privacy,
                            }"
                        />
                        <label
                            for="sendEmailPrivacyConsent"
                            class="form-check-label"
                        >
                            {{ $t("privacy_consent") }}
                            <a :href="privacyLink">{{
                                $t("privacy_policy")
                            }}</a>
                        </label>
                    </div>
                    <div class="form-check">
                        <input
                            id="sendEmailMarketingConsent"
                            v-model="consents.marketing"
                            class="form-check-input"
                            type="checkbox"
                            :class="{
                                'is-invalid': errors.errors.marketing,
                            }"
                        />
                        <label
                            for="sendEmailMarketingConsent"
                            class="form-check-label"
                        >
                            {{ $t("marketing_consent") }}
                        </label>
                    </div>
                    <div class="buttons mt-3">
                        <button type="submit" class="btn btn-success m-2">
                            {{ $t("send") }}
                        </button>
                        <button
                            @click="onClose()"
                            type="button"
                            class="btn btn-danger m-2"
                        >
                            {{ $t("close") }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.35s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<script>
import BaseModalContact from "./BaseModalContact";

export default {
    extends: BaseModalContact,

    data: function () {
        return {
            contact: {
                email: null,
                type: 0, // Lead
            },
            errors: {
                errors: {},
                message: null,
            },
            consents: {
                privacy: false,
                marketing: false,
            },
            isOfferRequest: false,
        };
    },
};
</script>
